import { ChangeDetectorRef, Component, ElementRef, HostBinding, OnDestroy, OnInit} from '@angular/core';
import { BaseView } from '@wizeoo/akm-common-lib';
import { WizEvent, WizEventManager, WizRoot } from '@wizeoo/akm-component-lib';
import { WIZ_EVENT_TYPE } from '@wizeoo/akm-core-lib';
import { Subscription } from 'rxjs';
import { RouteEngine } from 'src/app/manager/routing/route.engine';
import { Model } from 'src/app/model/model';
import { DeviceService } from 'src/app/services/device.service';

@Component({
  selector: 'information-bar',
  templateUrl: './information.bar.html'
})
export class InformationBar implements OnInit, OnDestroy {
  /**
   * Etat mobile courant fourni par DeviceService.
   * La valeur est conservee localement pour piloter le template de la barre
   * et synchronisee avec le modele global pour les autres vues.
   */
  public isMobile = false;

  /**
   * Indique si l'appareil est un iPhone moderne avec safe areas.
   * Utilise pour appliquer les ajustements CSS specifiques via HostBinding.
   */
  public isIphoneRounded = false;

  /**
   * Regroupe les abonnements au DeviceService afin de les liberer proprement
   * lorsque la barre d'information est detruite.
   */
  private subscriptions: Subscription[] = [];

  @HostBinding('class.information-bar-iphone')
  public get informationBarIphone(): boolean {
    return this.isIphoneRounded;
  }

  constructor(protected cdref: ChangeDetectorRef, el: ElementRef, private deviceService: DeviceService) {
  }
  

  ngOnInit() {
    WizEventManager.addListener(this, WizRoot.root(), WIZ_EVENT_TYPE.NAVIGATE_END, this.refresh);
    const mod = Model.getInstance();

    // Suit les changements mobile en temps reel pour adapter la barre
    // et conserver le singleton Model aligne avec l'etat device courant.
    this.subscriptions.push(this.deviceService.isMobile$.subscribe(value => {
      this.isMobile = value;
      mod.isMobile = value;
      this.cdref.detectChanges();
    }));

    // Suit les changements d'affichage iPhone/safe area, notamment apres
    // rotation ou redimensionnement du viewport.
    this.subscriptions.push(this.deviceService.isIphoneRounded$.subscribe(value => {
      this.isIphoneRounded = value;
      mod.isIphoneRounded = value;
      this.cdref.detectChanges();
    }));
  }

  ngOnDestroy() {
    // Evite les abonnements actifs apres destruction du composant.
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  public currentView: string = 'home';
  

  public doShow(view: string): boolean {
    const currV: BaseView = Model.getInstance().navigationEngine.getCurrentView();
    //let curr: string = this.currentView;
    if(this.currentView.toUpperCase() !== view.toUpperCase()) {
      return true;
    }
    return false;
  }

  public get isVerbose(): boolean {
    return WizRoot.verboseMode;
  }

  public refresh(e: WizEvent): void {
    this.currentView = e.value;
  } 

  /** déclenche une action */
  public do(action: string): void {
   switch (action) {   
      case "home":               
        Model.getInstance().navigationEngine.navigate(RouteEngine.INIT_VIEW);
        break;
      case "list":               
        Model.getInstance().navigationEngine.navigate(RouteEngine.LIST_VIEW);
        break; 
      case "thumb":               
        Model.getInstance().navigationEngine.navigate(RouteEngine.THUMB_VIEW);
        break;  
      case "gatling":               
        Model.getInstance().navigationEngine.navigate(RouteEngine.GATLING_VIEW);
        break; 
      case "log":               
        Model.getInstance().navigationEngine.navigate(RouteEngine.LOG_VIEW);
        break;       
      case "add":  
          Model.getInstance().currentPrototype = null;
          Model.getInstance().navigationEngine.navigate(RouteEngine.ADD_VIEW);
        break; 
      case "back":  
          window.history.back();
        break;    
    }
  }

}
